/* eslint-disable no-func-assign */
import React, { useState } from 'react';
import { FasUndoAlt, FasSlidersH } from 'assets/icons';
import Select from 'react-select';
import { Button } from 'components/CustomComponents';
import { withAppContext } from '@ctsu/loader';
import InstitutionTypeAhead from 'components/Fields/typeAheads/InstitutionTypeAhead';
import PersonTypeAhead from 'components/Fields/typeAheads/PersonTypeAhead';
import ProtocolAndStatusTypeAhead from 'components/Fields/typeAheads/ProtocolAndStatusTypeAhead';

import { ATCONSTANTS as ATC } from 'appconstants';

function SearchLabel({ label }) {
  return (
    <div
      data-id={`${ATC.PACKETID}${label
        .split(' ')
        .join('_')
        .toUpperCase()}${ATC.DIV}`}
      className="mr-1 font-semibold color-dark-blue"
    >
      {`${label}`}
    </div>
  );
}

function ButtonField(props) {
  const { name } = props;
  return (
    <div className="ml-2 align-self-center" style={{ marginTop: '1.25rem' }}>
      <Button data-id={`${ATC.PACKETID}${name.split(' ').join('_').toUpperCase()}${ATC.BUTTON}`} {...props} />
    </div>
  );
}

function SelectField({
  value, getDropdownOptions, index, onChangeSelection
}) {
  return (
    <div>
      <SearchLabel label="Identifier" />
      <Select
        key={`second-search-${index}`}
        data-id={`${ATC.PACKETID}SECOND_SEARCH_${index}${ATC.SELECT}`}
        className="reactSelect-wrapper"
        classNamePrefix="reactSelect"
        styles={{ control: (provided) => ({ ...provided, minWidth: '12rem' }) }}
        options={getDropdownOptions(index)}
        onChange={(o) => onChangeSelection(o, index)}
        value={value || null}
        menuPosition="fixed"
        isClearable
      />
    </div>
  );
}

function FilterSiteCTEPId({
  field, label, searchData, setSearchData
}) {
  const [selectedSiteId, setSelectedSiteId] = useState(null);

  const onInstitutionChange = (selectedValue) => {
    if (selectedValue != null) {
      const { value } = selectedValue;
      setSelectedSiteId(selectedValue);
      if (value) {
        setSearchData({ ...searchData, [field]: value });
      } else {
        const newSerchData = { ...searchData };
        delete newSerchData[field];
        setSearchData(newSerchData);
      }
    } else {
      setSelectedSiteId(null);
    }
  };

  return (
    <div className="ml-2 col-2">
      <SearchLabel label={label} />
      <InstitutionTypeAhead value={selectedSiteId} onChange={onInstitutionChange} />
    </div>
  );
}

function FilterProtocolNumber({
  context, field, label, searchData, setSearchData
}) {
  const [selectedProtocolNumber, setSelectedProtocolNumber] = useState(null);

  const onProtocolNumberChange = (selectedValue) => {
    if (selectedValue != null) {
      const { value } = selectedValue;
      setSelectedProtocolNumber(selectedValue);
      if (value) {
        setSearchData({ ...searchData, [field]: value });
      } else {
        const newSerchData = { ...searchData };
        delete newSerchData[field];
        setSearchData(newSerchData);
      }
    } else {
      setSelectedProtocolNumber(null);
    }
  };

  return (
    <div className="ml-2 col-2">
      <SearchLabel label={label} />
      <ProtocolAndStatusTypeAhead context={context} value={selectedProtocolNumber} onChange={onProtocolNumberChange} />
    </div>
  );
}

FilterProtocolNumber = withAppContext(FilterProtocolNumber);

function FilterPersonID({
  field, label, searchData, setSearchData
}) {
  const [selectedPersonId, setSelectedPersonId] = useState(null);
  const onPersonChange = (selectedValue) => {
    if (selectedValue != null) {
      const { value } = selectedValue;
      setSelectedPersonId(selectedValue);
      if (value) {
        setSearchData({ ...searchData, [field]: value });
      } else {
        const newSerchData = { ...searchData };
        delete newSerchData[field];
        setSearchData(newSerchData);
      }
    } else {
      setSelectedPersonId(null);
    }
  };

  return (
    <div className="ml-2 col-2">
      <SearchLabel label={label} />
      <PersonTypeAhead value={selectedPersonId} onChange={onPersonChange} />
    </div>
  );
}

const dropdownOptions = [
  { label: 'Person ID', value: 'personCtepId' },
  { label: 'Site CTEP ID', value: 'siteCtepId' },
  { label: 'Protocol', value: 'protocolNumber' }
];

function PacketFilters({
  onSearch,
  onClearExternalFilter,
  selectedOptions,
  setSelectedOptions,
  searchData,
  setSearchData
}) {
  const resetSearchData = (options) => {
    const availabelKeys = [];
    options.forEach((o) => availabelKeys.push(o.value));
    const data = { ...searchData };
    Object.keys(searchData).forEach((key) => {
      if (availabelKeys.indexOf(key) === -1) {
        delete data[key];
      }
    });
    setSearchData(data);
  };

  const onChangeSelection = (option, index) => {
    const options = [...selectedOptions];
    if (option != null) {
      options[index] = option;
    } else if (index === 0) {
      options.shift();
    } else {
      options.pop();
    }
    resetSearchData(options);
    setSelectedOptions(options);
  };

  const searchHandler = () => onSearch(searchData);

  const getDropdownOptions = (index) => {
    const options = dropdownOptions.filter((o) => {
      if (selectedOptions.length > 0) {
        const selectedOption = selectedOptions[index];
        if (selectedOption != null && selectedOption.value === o.value) {
          return true;
        }
        return selectedOptions.find((o2) => o.value === o2.value) == null;
      }
      return true;
    });
    return options;
  };
  const getTypeAhead = (val, label) => {
    switch (val) {
      case 'siteCtepId':
        return (
          <FilterSiteCTEPId
            field={val}
            label={label}
            searchData={searchData}
            onSearch={searchHandler}
            setSearchData={setSearchData}
          />
        );
      case 'personCtepId':
        return (
          <FilterPersonID
            field={val}
            label={label}
            searchData={searchData}
            onSearch={searchHandler}
            setSearchData={setSearchData}
          />
        );
      case 'protocolNumber':
        return (
          <FilterProtocolNumber
            field={val}
            label={label}
            searchData={searchData}
            onSearch={searchHandler}
            setSearchData={setSearchData}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="app-body-center row align-items-center mb-2">
      <div className="content-page-title my-1 mr-2" role="heading" aria-level="3" title="External Filters">
        <div>&nbsp;</div>
        <FasSlidersH className="mr-1" />
      </div>
      <div className="row">
        <SelectField
          value={selectedOptions[0]}
          getDropdownOptions={getDropdownOptions}
          index={0}
          onChangeSelection={onChangeSelection}
        />
        {selectedOptions.length > 0 ? (
          <>
            {getTypeAhead(selectedOptions[0].value, selectedOptions[0].label)}
            <div className="mx-3 my-1" style={{ borderLeft: '1px solid #D1E1E9' }} />
            <SelectField
              value={selectedOptions[1]}
              getDropdownOptions={getDropdownOptions}
              index={1}
              onChangeSelection={onChangeSelection}
            />
            {selectedOptions.length > 1 ? (
              <>
                {' '}
                {getTypeAhead(selectedOptions[1].value, selectedOptions[1].label)}
                {' '}
              </>
            ) : null}
            <ButtonField className="btn turquoise ml-2" name="Apply Data Filters" buttonHandler={searchHandler} />
            <ButtonField
              className="fn-btn color-dark-blue"
              name="Clear Data Filters"
              buttonHandler={onClearExternalFilter}
              startIcon={<FasUndoAlt />}
            />
          </>
        ) : null}
      </div>
    </div>
  );
}

export default PacketFilters;
